import React from "react";
import api from "services/api";
import { useGlobalStateContext } from "state/GlobalState";

const useCurrentTrackHook = () => {
  const {
    state: { playerQueueIds, currentlyPlayingIndex },
  } = useGlobalStateContext();

  const [currentTrack, setCurrentTrack] = React.useState<Track>();
  const [isLoading, setIsLoading] = React.useState(false);

  const fetchTrackCallback = React.useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      const { result } = await api.get<Track>(`tracks/${id}`);
      setCurrentTrack(result);
    } catch {
      setCurrentTrack(undefined);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const currentTrackId = currentTrack?.id;
  const playerQueueIdAtIndex =
    currentlyPlayingIndex !== undefined &&
    playerQueueIds?.[currentlyPlayingIndex];

  const playerQueueIdsLength = playerQueueIds.length;

  // FIXME: Something is causing this to trigger twice and
  // call the above callback twice.
  React.useEffect(() => {
    if (playerQueueIdsLength && playerQueueIdAtIndex) {
      if (currentTrackId !== playerQueueIdAtIndex) {
        // setCurrentTrack(undefined);
        fetchTrackCallback(playerQueueIdAtIndex);
      }
    } else {
      setCurrentTrack(undefined);
    }
  }, [
    fetchTrackCallback,
    playerQueueIdsLength,
    playerQueueIdAtIndex,
    currentTrackId,
  ]);

  return {
    currentTrack,
    isLoading,
  };
};

export default useCurrentTrackHook;
